import {INeighborhoodDetectiveExternalProperty, INeighborhoodDetectiveProperty} from "../types/INeighborhoodDetectiveSummary";

export const isNeighborhoodDetectiveAvailable = (property: INeighborhoodDetectiveProperty): boolean => {
    return Boolean(property.rp_id);
};

export const isExternalNeighborhoodDetectiveAvailable = (externalProperty: INeighborhoodDetectiveExternalProperty | null | undefined): boolean => {
    return Boolean(externalProperty?.id && externalProperty.has_coordinates);
};
import {INeighborhoodDetectiveExternalProperty, INeighborhoodDetectiveProperty} from "../types/INeighborhoodDetectiveSummary";

export const isNeighborhoodDetectiveAvailable = (property: INeighborhoodDetectiveProperty): boolean => {
    return Boolean(property.rp_id);
};

export const isExternalNeighborhoodDetectiveAvailable = (externalProperty: INeighborhoodDetectiveExternalProperty | null | undefined): boolean => {
    return Boolean(externalProperty?.id && externalProperty.has_coordinates);
};
